import { useContext } from 'react';

import { MediaLibrarySearchResultContext } from '~modules/media-library/context/MediaLibrarySearchResult';

export default function useMediaLibrarySearchResult() {
  const context = useContext(MediaLibrarySearchResultContext);
  if (!context) {
    throw new Error(`useMediaLibrarySearchResult must be used within a MediaLibrarySearchResultProvider`);
  }
  return context;
}
